"use client";

import { useState } from "react";
import { ImageProps } from "./MediaItem";

type MediaItemImageProps = {
  imageProps: ImageProps;
  objectFit: "cover" | "contain";
  fetchPriority: "auto" | "high" | "low" | undefined;
};

export const MediaItemImage = ({
  imageProps,
  objectFit,
  fetchPriority,
}: MediaItemImageProps) => {
  const [load, setLoad] = useState(false);

  return (
    /* wrong typed I guess because alt is inside rest */
    /* component is used inside <picture> tag */
    /* eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element */
    <img
      {...(imageProps ?? {})}
      style={{
        ...(imageProps?.style ?? {}),
        width: "100%",
        height: "100%",
        objectFit,
        ...(load && { backgroundImage: "unset" }),
      }}
      onLoad={() => {
        setLoad(true);
      }}
      {...(fetchPriority && { fetchpriority: fetchPriority })}
    />
  );
};
